import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain as checkoutShippingChain,
    UpdateContext as DefaultCheckoutShippingUpdateContext,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateBillTo";
import {
    chain as onePageCheckoutChain,
    UpdateContext as DefaultOnePageCheckoutUpdateContext,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateBillTo";
import { promoteContextCookiesToSharedDomain } from "@tSurya/Handlers/SharedCookieContext";

const CheckoutShippingUpdateContext: typeof DefaultCheckoutShippingUpdateContext = props => {
    DefaultCheckoutShippingUpdateContext(props);
    promoteContextCookiesToSharedDomain();
};

replaceInChain(checkoutShippingChain, DefaultCheckoutShippingUpdateContext, CheckoutShippingUpdateContext);

const OnePageCheckoutUpdateContext: typeof DefaultOnePageCheckoutUpdateContext = props => {
    DefaultOnePageCheckoutUpdateContext(props);
    promoteContextCookiesToSharedDomain();
};

replaceInChain(onePageCheckoutChain, DefaultOnePageCheckoutUpdateContext, OnePageCheckoutUpdateContext);